export default function identity(a) { return a; }
